import { useEffect } from 'react'
import { revealAfterBoot } from '@/lib/boot-guard'

/**
 * index.html's boot guard hides the prerendered landing page on the app host
 * and on unknown paths. This shows the page once React has committed its first
 * render, which has replaced that markup. main.tsx mounts it outside the
 * ErrorBoundary, so a crash still reveals the page.
 */
export function BootReveal() {
  useEffect(() => {
    revealAfterBoot()
  }, [])
  return null
}
